<template>
  <v-container>
    <site-management></site-management>
  </v-container>
</template>

<script>
import SiteManagement from '@/components/SiteManagement'

export default {
  components: { SiteManagement }
}
</script>
